import { useSiderMenus } from '@/features/menus'
import { useHistory, useLocation } from '@/router'
import { reflectionStorage, schoolIdStorage, store } from '@/store'
import { State } from '@seiue/ui'
import { uniqBy } from '@seiue/util'
import { useAtomValue } from 'jotai'
import { modalRoutes, routes } from 'packages/route'
import { NestedRoute } from 'packages/route/components/NestedRoute'
import { PermEnum, permApi } from 'packages/sdks-next/growp'
import { AnyType } from 'packages/types'
import { WebLayout } from 'packages/web-layout'
import { useActivePath } from 'packages/web-layout/hooks'
import { getActiveMenuPath } from 'packages/web-layout/utils'
import React, { useCallback, useEffect, useState } from 'react'

import { useInitAdminFeatures, useInitUserFeatures } from '../hooks'

import { HeaderRight } from './HeaderRight'
import { SiderLogo } from './SiderLogo'
import { goAdminPageAtom } from './atoms'
import { PermToRouteName } from './utils'

const InnerLayout: React.FC<{
  navbarBackgroundColor: string
  sliderBackgroundColor: string
}> = ({ navbarBackgroundColor, sliderBackgroundColor }) => {
  const { data: perms, loading } = permApi.useQueryMePerms()
  const goAdminPage = useAtomValue(goAdminPageAtom)
  const getSiderMenus = useCallback(() => {
    const menus = useSiderMenus()
    const { schoolBackgroundPerms } = perms || {}
    if (schoolBackgroundPerms?.includes(PermEnum.All)) {
      return menus
    }
    return menus.filter(
      (i) => i.perm && schoolBackgroundPerms?.includes(i.perm)
    )
  }, [perms])
  // 获取当前路径
  const activePath = useActivePath()
  // 获取菜单路径
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    const isLogin = !!store.get(reflectionStorage)
    const schoolId = store.get(schoolIdStorage)
    if (!isLogin || !perms || !schoolId) return
    const siderMenus = getSiderMenus()

    if (location.pathname === '/') {
      const { schoolBackgroundPerms } = perms || {}
      if (!schoolBackgroundPerms?.length || !goAdminPage) {
        history.push('UserGateway')
      } else if (siderMenus[0].perm) {
        history.push(PermToRouteName.get(siderMenus[0].perm) as AnyType)
      }
    }
  }, [perms])

  const siderMenus = getSiderMenus()
  const activeMenuPath = getActiveMenuPath(activePath, siderMenus)
  useInitAdminFeatures(!!perms?.schoolBackgroundPerms?.length)
  useInitUserFeatures()

  const [showIndex, setShowIndex] = useState<boolean>(true)

  if (loading) return <State.Loading />
  return (
    <WebLayout
      activeMenuPath={activeMenuPath}
      logoSlot={<SiderLogo />}
      menus={siderMenus || []}
      HeaderRight={
        <HeaderRight
          setShowIndex={setShowIndex}
          showIndex={showIndex}
          perms={perms}
          isForeground={false}
        />
      }
      siderFooter={null}
      navbarBackgroundColor={navbarBackgroundColor}
      sliderBackgroundColor={sliderBackgroundColor}
    >
      <NestedRoute
        routes={uniqBy(routes, 'path')}
        modalRoutes={modalRoutes}
        authFunction={() => {
          const paths = siderMenus.map((i) => i.path)
          if (paths.includes(activeMenuPath)) {
            return true
          }
          return false
        }}
      />
    </WebLayout>
  )
}

/**
 * 基于 WebLayout 封装的 Layout 组件
 *
 * @returns component
 */
export const AdminLayout: React.FC = () => {
  return (
    <InnerLayout
      navbarBackgroundColor="#fff"
      sliderBackgroundColor="#fff"
    />
  )
}
